module.exports = __webpack_public_path__ + "img/meslo-light.a0dcb9fa.png";